import type { Permission } from '@mustauto/types/permissions';

/**
 * A permissão que cada TELA do painel pede para aparecer (Fase 3) — a mesma da
 * rota da API que a alimenta. Tela sem entrada é de qualquer membro. Fora do
 * caminho natural de quem não pode, a tela some do menu e da paleta, e quem
 * chega pela URL volta para as OS (decisão 5 da prévia).
 *
 * Lista de permissões = basta uma delas.
 *
 * D10: tela que o mecânico abre hoje continua abrindo. Configurações (as
 * notificações são da própria pessoa) e Vagas (o mapa é de todos) ficam fora
 * daqui: dentro delas, as abas e os botões de edição pedem a permissão.
 */
export const ROUTE_ACCESS: Record<string, readonly Permission[]> = {
  '/dashboard': ['painel.ver'],
  '/service-orders/new': ['os.abrir'],
  '/in-shop': ['painel.ver'],
  '/finance': ['financeiro.ver'],
  '/reports': ['painel.faturamento'],
};

export function canOpenRoute(path: string, can: (p: Permission) => boolean): boolean {
  const needed = ROUTE_ACCESS[path];
  return !needed || needed.some((p) => can(p));
}
